import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/kidizen-photo-tips';

export default function Example() {
  return (
    <>
      <Head>
        <title>Make Your Listings Effective With These Kidizen Photo Tips</title>
        <meta
          name='description'
          content="Don't miss a beat when it comes to ensuring that your listings are as effective to catch any buyer's attention! Learn how to make them great with these Kidizen photo tips that will make your photos stand out from your competition."
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/kidizen-photo-tips' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/kidizen-photo-tips' />
        <meta property='og:title' content='Make Your Listings Effective With These Kidizen Photo Tips' />
        <meta
          property='og:description'
          content="Don't miss a beat when it comes to ensuring that your listings are as effective to catch any buyer's attention! Learn how to make them great with these Kidizen photo tips that will make your photos stand out from your competition."
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-06-14T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-06-14T00:00:00-00:00' />
        <meta property='article:tag' content='Kidizen' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
